//app/richiestaFerie/richiestaFerie.js

(function () {
	'use strict';
	var controllerId = 'richiestaFeriePermessi';
	angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$routeParams', '$filter', '$location', 'common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', '$translate', 'moment', richiestaFeriePermessiFn]);

	function richiestaFeriePermessiFn($rootScope, $scope, $routeParams, $filter, $location, common, bDialog, $uibModal, datacontext, sectionMenu, $translate, moment) {
		var getLogFn = common.logger.getLogFn;
		var log = getLogFn(controllerId);
		var logError = getLogFn(controllerId, 'logError');
		var logSuccess = getLogFn(controllerId, 'logSuccess');
		$rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

		var vm = this;
		vm.view = 'list';       //Opzione list or detail
		vm.setView = setView;
		vm.sectionMenu = sectionMenu.setSection('RichiestaFeriePermessi');
		vm.record = {};
		vm.records = [];
		vm.date = [];  //Questo contiene le date da inserire nella tabella ore
		vm.colSabati = [];
		vm.colDomeniche = [];
		vm.colFestivo = [];
		vm.colFerie = []; //1 - da validare, 2 - approvata 
		vm.colTitle = [];
		vm.righeC = [];
		vm.righeG = [];
		vm.listaNominativi = [];
		vm.countRecords = 0;
		vm.index = 0;
		vm.exportDisabled = false;
		vm.addDisabled = false;
		vm.pageSize = 30;
		vm.page = 1;
		vm.loading = false;
		vm.super = $rootScope.isAuthorized('SUPER');
		vm.personale = $rootScope.isAuthorized('PERSONALE');
		vm.capoSezione = $rootScope.isAuthorized('CAPOSEZIONE');
		vm.utente = $rootScope.isAuthorized('USER');

		//Elenco per Ordinamento
		vm.list = {};
		vm.list.ordine = ['Data', 'Stato'];
		vm.list.ordine = common.setOrdine(vm.list.ordine);
		vm.ordine = vm.list.ordine[0];
		vm.selectOrdine = function (item) {
			vm.ordine = item;
			vm.cerca();
		};

		//Filtro
		vm.filter = {};
		vm.filter.stato = vm.fStato = -1;
		vm.filter.ricerca = vm.fRicerca = '';
		vm.filter.dtInizio = vm.fDtInizio == null ? '' : $filter('date')(vm.fDtInizio, 'dd/MM/yyyy');
		vm.filter.dtFine = vm.fDtFine == null ? '' : $filter('date')(vm.fDtFine, 'dd/MM/yyyy');

		//Metodi su interfaccia
		vm.cerca = cerca;
		vm.loadMore = getAllByFilter;
		vm.loadAll = getAll;
		vm.delete = deleteItem;
		vm.add = addRichiestaFeriePermessi;
		vm.edit = editRichiestaFeriePermessi;
		vm.inoltra = inoltraItem;
		vm.showNote = showNote;
		vm.getTimeSheet = getTimeSheet;
		vm.next = next;
		vm.prev = prev;
		vm.vai = vai;

		//datapicker
		vm.open = function ($event) {
			$event.preventDefault();
			$event.stopPropagation();

			vm.opened = !vm.opened;
			vm.opened2 = false;
		};

		vm.open2 = function ($event) {
			$event.preventDefault();
			$event.stopPropagation();

			vm.opened2 = !vm.opened2;
			vm.opened = false;
		};

		vm.dateOptions = {
			formatYear: 'yy',
			startingDay: 1
		};

		vm.format = 'dd/MM/yyyy';

		// ---- ACTIVATE -------
		activate();

		function activate() {
			var promises = [getHolidays()];
			common.activateController(promises, controllerId).then(function () {
				datacontext.timeSheet_getDate().then(function (data) {
					if (data) {
						data = new Date(data);
						vm.fAnno = data.getFullYear();
						vm.fMese = data.getMonth() + 1;
						vm.fGiorno = 0;
						vm.fiAnno = data.getFullYear();
						vm.fiMese = data.getMonth();
						vm.fiGiorno = 1;
					}
				});
			});
		}

		//****************************************************
		// METODI 
		//****************************************************
		function setView(view) {
			if (view == 'list')
				cerca();
			return vm.view = view;
		}

		function cerca() {
			vm.records = [];
			vm.countRecords = 0;
			vm.page = 1;
			vm.filter.stato = vm.fStato == null ? 0 : vm.fStato;
			vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;
			vm.filter.dtInizio = vm.fDtInizio == null ? '' : $filter('date')(vm.fDtInizio, 'dd/MM/yyyy');
			vm.filter.dtFine = vm.fDtFine == null ? '' : $filter('date')(vm.fDtFine, 'dd/MM/yyyy');

			vm.loading = false;
			countByFilter();
			return getAllByFilter();
		}

		function countByFilter() {
			return datacontext.richiestaFerie_countAll(vm.filter.dtInizio, vm.filter.dtFine, vm.filter.stato).then(function (data) {
				if (data) {
					vm.countRecords = data;
				}
			});
		}

		function getAllByFilter() {
			if (vm.loading === true) return;

			if (vm.countRecords == 0) countByFilter();
			else if (vm.countRecords <= vm.records.length) return;

			vm.loading = true;
			return datacontext.richiestaFerie_getAllByFilter(vm.pageSize, vm.page, vm.filter.dtInizio, vm.filter.dtFine, vm.filter.stato, vm.ordine.value).then(function (data) {
				if (data.constructor === Array) {
					vm.page++;
					vm.records.push.apply(vm.records, data);
				}
				vm.loading = false;
			});
		}

		function getAll() {
			if (vm.records.length < vm.countRecords) {
				getAllByFilter().then(function () { getAll(); });
			}
		}

		function addRichiestaFeriePermessi() {
			var richiesta = { Id: 0 };
			var modalInstance = $uibModal.open({
				backdrop: 'static',
				keyboard: false,
				templateUrl: '/app/richiestaFerie/modal/richiestaFerieAddEdit.html?version=30',
				controller: 'richiestaFeriePermessiAddEdit',
				windowClass: 'modal-wide',
				resolve: {
					richiesta: function () {
						return richiesta;
					}
				}
			});

			modalInstance.result.then(function (returnItem) {
				if (!returnItem) return logError($translate.instant('Errore durante inserimento del dato'));

				if (returnItem != 'chiusoManualmente') {
					logSuccess($translate.instant('Richiesta aggiunta con successo'));
					vm.cerca();
				}
			});
		}

		function editRichiestaFeriePermessi(item) {
			var modalInstance = $uibModal.open({
				backdrop: 'static',
				keyboard: false,
				templateUrl: '/app/richiestaFerie/modal/richiestaFerieAddEdit.html?version=30',
				controller: 'richiestaFeriePermessiAddEdit',
				windowClass: 'modal-wide',
				resolve: {
					richiesta: function () {
						return item;
					}
				}
			});

			modalInstance.result.then(function (returnItem) {
				if (!returnItem) return logError($translate.instant('Errore durante inserimento del dato'));

				if (returnItem != 'chiusoManualmente') {
					logSuccess($translate.instant('Richiesta modificata con successo'));
					vm.cerca();
				}
			});
		}

		function inoltraItem(item) {
			var modalInstance = $uibModal.open({
				backdrop: 'static',
				keyboard: false,
				templateUrl: '/app/richiestaFerie/modal/inoltraFerie.html?version=30',
				controller: 'inoltraFerie',
				resolve: {
					richiesta: function () {
						return item;
					}
				}
			});

			modalInstance.result.then(function (returnItem) {
				if (returnItem != null) {
					if (returnItem.Id) {
						logSuccess($translate.instant('Richiesta Inoltrata'));
						cerca();
					}
					else
						logError($translate.instant('Impossibile inoltrare la Richiesta'));
				}
			});
		}

		function deleteItem(item) {
			var modalInstance = $uibModal.open({
				backdrop: 'static',
				keyboard: false,
				templateUrl: '/app/richiestaFerie/modal/eliminaFerie.html?version=30',
				controller: 'eliminaFerie',
				resolve: {
					richiesta: function () {
						return item;
					}
				}
			});

			modalInstance.result.then(function (returnItem) {
				if (returnItem == 'ok') {
					return datacontext.richiestaFerie_delete(item.Id).then(function (data) {
						if (data != "204") return logError($translate.instant('Impossibile eliminare la richiesta'));
						logSuccess($translate.instant('Richiesta eliminata con successo'));
						vm.cerca();
					});
				}
			});
		}

		function showNote(note) {
			bDialog.confirmationDialog('Note ' + $translate.instant('richiesta'), note).then(function () { });
		}


		function next() {
			var x = parseInt(vm.fMese) + 1;
			if (x > 12) {
				vm.fMese = 1;
				vm.fAnno++;
			}
			else
				vm.fMese++;

			vm.filter.dtInizio = '01/' + vm.fMese + '/' + vm.fAnno;
			var temp_date = new Date(vm.fAnno, vm.fMese, 0);
			vm.filter.dtFine = temp_date.getDate() + '/' + vm.fMese + '/' + vm.fAnno;

			getTimeSheet();
		}

		function prev() {
			var x = vm.fMese - 1;

			if (x <= 0) {
				vm.fMese = 12;
				vm.fAnno--;
			}
			else
				vm.fMese--;

			vm.filter.dtInizio = '01/' + vm.fMese + '/' + vm.fAnno;
			var temp_date = new Date(vm.fAnno, vm.fMese, 0);
			vm.filter.dtFine = temp_date.getDate() + '/' + vm.fMese + '/' + vm.fAnno;

			getTimeSheet();
		}

		function vai() {
			vm.filter.dtInizio = '01/' + vm.fMese + '/' + vm.fAnno;
			var temp_date = new Date(vm.fAnno, vm.fMese, 0);
			vm.filter.dtFine = temp_date.getDate() + '/' + vm.fMese + '/' + vm.fAnno;
			getTimeSheet();
		}

		function getTimeSheet() {
			vm.loading = true;
			if (vm.fAnno < 0)
				vm.fAnno = new Date().getFullYear();
			if (vm.fMese < 1 || vm.fMese > 12)
				vm.fMese = 1;

			var dataFine = new Date(vm.fAnno, vm.fMese, 0);

			vm.giorni = [];
			vm.gSett = [];
			vm.colFestivo = [];
			vm.colSabati = [];
			vm.colDomeniche = [];
			vm.righeC = [];
			vm.rigaTot = [];
			vm.Totale = 0;
			vm.TotaleApprovate = [];
			vm.TotaleDaValidare = [];

			for (var i = 0; i < dataFine.getDate(); i++) {
				vm.rigaTot.push({ "id": i, "value": 0 });
				vm.date[i] = moment().year(vm.fAnno).month(vm.fMese - 1).date(i + 1);

				vm.giorni[i] = String(vm.date[i].format('L')).substring(0, 5);
				vm.gSett[i] = String(vm.date[i].format('dddd')).substring(0, 3);

				if (vm.gSett[i] == 'Sab' || vm.gSett[i] == 'Sat')
					vm.colSabati[i] = true;
				else
					vm.colSabati[i] = false;
				if (vm.gSett[i] == 'Dom' || vm.gSett[i] == 'Sun')
					vm.colDomeniche[i] = true;
				else
					vm.colDomeniche[i] = false;

				vm.colFestivo[i] = false;

				var giorno = vm.date[i].date();
				var mese = vm.date[i].month();
				var anno = vm.date[i].year();
				var check = null;
				check = _.find(vm.holidays, function (o) {
					return (o.giorno == giorno && o.mese - 1 == mese && (o.anno == 0 || o.anno == anno))
				});

				if (check != null) {
					vm.colFestivo[i] = true;
					vm.colTitle[i] = check.descrizione;
				}
				else {
					vm.colFestivo[i] = false;
				}
			}

			//eliminazione ultimo elemento array in caso di mese inferiore a 31 giorni
			if (dataFine.getDate() < 31 && vm.date.length == 31) {
				vm.date.pop();
			}
			if (dataFine.getDate() < 31 && vm.date.length == 31 && dataFine.getMonth() == 1) {
				vm.date.pop();
				vm.date.pop();
				vm.date.pop();
			}
			if (dataFine.getDate() < 30 && vm.date.length == 30 && dataFine.getMonth() == 1) {
				vm.date.pop();
				vm.date.pop();
			}

			//Da qui inizia la parte per le righe
			datacontext.richiestaFerie_getReportFerie(vm.filter.dtInizio, vm.filter.dtFine).then(function (data) {
				var ordinario = _.chain(data).groupBy(function (value) { return [value.Nominativo, value.Matricola]; }).map(function (v, i) {
					var iArr = i.split(',');
					return {
						Nominativo: iArr[0],
						Matricola: iArr[1],
						allInfo: v
					}
				}).value();
				vm.listaNominativi = ordinario;
				for (var k = 0; k < vm.listaNominativi.length; k++) {
					vm.TotaleApprovate[k] = 0;
					vm.TotaleDaValidare[k] = 0;
					for (var i = 0; i < dataFine.getDate(); i++) {

						if (vm.listaNominativi[k].allInfo[i].Stato == 2) { //Caso giorno di ferie ACCETTATO
							vm.TotaleApprovate[k] += vm.listaNominativi[k].allInfo[i].Ore;
						}
						if (vm.listaNominativi[k].allInfo[i].Stato == 1) { //Caso giorno di ferie INOLTRATO
							vm.TotaleDaValidare[k] += vm.listaNominativi[k].allInfo[i].Ore;
						}
					}
				}

				var ferie = _.chain(_.filter(data, { 'Stato': 1, 'Stato': 2 })).groupBy(function (value) { return [value.Nominativo]; }).map(function (v, i) {
					var iArr = i.split(',');
					return {
						nominativo: iArr,
						ore: v
					}
				}).value();

				if (ferie && ferie.length > 0) {
					vm.righeC = ferie;
					//Segno le ore   
					vm.righeC.forEach(function (rigaC) {
						var somma = 0;
						rigaC.oreC = [];
						for (var k = dataFine.getDate(); k < dataFine.getDate(); k++) {

							rigaC.Totale = somma;   //Somma per riga
							rigaC.Totale = parseFloat(rigaC.Totale.toFixed(2));
						}
					});
				}
			});
			vm.loading = false;
		}

		function getHolidays() {
			return vm.holidays = datacontext.festivita_getAll().then(function (data) {
				return vm.holidays = data;
			});
		}
	}
})();
